import { Link } from "react-router-dom";
import { PRODUCT_MARKS } from "../../brand/marks";
import { PILLARS, PRODUCT_MENU_CARDS } from "../../nav/navigation";

export function ProductsMenu({ onNavigate }: { onNavigate: () => void }) {
  return (
    <div className="mm mm--rail">
      <nav className="mm__rail" aria-label="Product categories">
        <Link to="/products" onClick={onNavigate}>
          Overview
        </Link>
        {PILLARS.map((pillar) => (
          <Link key={pillar.key} to={pillar.href} onClick={onNavigate}>
            {pillar.name}
          </Link>
        ))}
        <Link to="/products" className="mm__rail-all" onClick={onNavigate}>
          See All Products →
        </Link>
      </nav>

      <div className="mm__grid">
        {PRODUCT_MENU_CARDS.map((item) => {
          const Mark = PRODUCT_MARKS[item.mark];
          return (
            <Link
              key={item.slug}
              to={item.href}
              className="mm__card"
              onClick={onNavigate}
            >
              <span className="mm__lockup">
                <Mark size={30} />
                <b>{item.name}</b>
              </span>
              <span className="mm__descriptor">{item.descriptor}</span>
              <span className="mm__blurb">{item.blurb}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
